import angular from 'angular'

angular.module('admin.affiliates.edit', []).controller('AffiliatesEditCtrl', AffiliatesEditCtrl)

/** @ngInject */
function AffiliatesEditCtrl($scope, $state, $stateParams, $timeout, AffiliatesService) {
  var vm = this
  vm.model = {}
  vm.id = parseInt($stateParams.id)

  vm.types = [
    {
      id: 0,
      name: 'Social Influencer',
    },
    {
      id: 1,
      name: 'Blogger',
    },
    {
      id: 2,
      name: 'Website',
    },
    {
      id: 3,
      name: 'Email',
    },
    {
      id: 4,
      name: 'Retail Partner',
    },
    {
      id: 5,
      name: 'Licensor',
    },
    {
      id: 6,
      name: 'Conference',
    },
    {
      id: 7,
      name: 'Friend',
    },
    {
      id: 8,
      name: 'Other',
    },
  ]

  vm.paymentTypes = [
    {
      id: 0,
      name: 'Paypal',
    },
  ]

  if (vm.id !== 0) {
    AffiliatesService.get(vm.id).then(function (result) {
      vm.model = result.results
    })
  }

  vm.save = function () {
    var model = angular.copy(vm.model)
    if (
      model.email === undefined ||
      model.fn === undefined ||
      model.ln === undefined ||
      model.bn === undefined
    ) {
      swal('Required email, first name, last name, business name fields', '', 'error')
      return
    }

    if (model.email === '' || model.fn === '' || model.ln === '' || model.bn === '') {
      swal('Required email, first name, last name, business name fields', '', 'error')
      return
    }

    if (model.id !== undefined && model.id !== '' && model.id !== 0) {
      AffiliatesService.update(model.id, model).then(
        function () {
          $timeout(function () {
            $state.go('admin.affiliates')
          }, 500)
        },
        function (err) {
          if (err.error.message.indexOf('uix_affiliate_email') !== -1) {
            swal('E-mail already registered', '', 'error')
          } else {
            swal(err.error.message, '', 'error')
          }
        },
      )
    } else {
      AffiliatesService.save(model).then(
        function () {
          $timeout(function () {
            $state.go('admin.affiliates')
          }, 500)
        },
        function (err) {
          if (err.error.message.indexOf('uix_affiliate_email') !== -1) {
            swal('E-mail already registered', '', 'error')
          } else {
            swal(err.error.message, '', 'error')
          }
        },
      )
    }
  }

  vm.cancel = function () {
    $state.go('admin.affiliates')
  }
}
